export default __webpack_public_path__ + "madfit-devices_tablet.bae93214.png";